import { store } from 'src/store';
import en from './en.json';
import en_compliance from './en_compliance.json';
import en_buildings from './en_buildings.json';

const getMessageJSON = (message: string | null) => {
  switch (message) {
    case 'en.json':
      return en;
    case 'en_compliance.json':
      return en_compliance;
    case 'en_buildings.json':
      return en_buildings;
    default:
      return {};
  }
};

export const getMessage = (textField: string) => {
  const state = store.getState();
  const message = state.onBoarding.config?.message || null;
  const json: any = getMessageJSON(message);
  return json[textField];
};
